import { initMap } from './map'
import { searchItem } from './components/searchitem'

// export const searchIndex = `${tlGlobal.templateDirectory}/reseller_search_result.json`
const devLocations = ['localhost', '.dev', '192.']
const isDev = devLocations.some((devLocation) => document.location.origin.includes(devLocation))

export let searchIndex

if (isDev) {
    searchIndex = `${document.location.origin}/torplyktan/reseller_search_result.json`
} else {
    searchIndex = `${document.location.origin}/reseller_search_result.json`
}

let post_list
const searchResult = document.querySelector('.reseller-search-result')
export function populateResults() {
    if (!document.querySelector('.map')) {
        return
    }
    // const htmlLang = document.querySelector('html').getAttribute('lang')
    // const currentLang = htmlLang.split('-')[0]
    let markers = []

    fetch(searchIndex)
        .then((blob) => blob.json())
        .then((datas) => {
            post_list = datas.sort((a, b) => {
                if (a.title < b.title) {
                    return -1
                }
                if (a.title > b.title) {
                    return 1
                }
                return 0
            })

            const searchItems = post_list
                .map((post) => {
                    const id = post.id
                    const title = post.title
                    const city = post.city
                    const link = post.link
                    const categories = post.categories
                    const lat = post.lat
                    const lng = post.lng
                    const lang = post.lang

                    if (lat || lng) {
                        markers.push(post)
                        return searchItem(id, title, city, link, categories, lat, lng, lang)
                    }
                })
                .join('')

            searchResult.innerHTML = searchItems
            initMap(markers)
        })
        .catch((error) => {
            console.log(error)
        })
}

document.addEventListener('DOMContentLoaded', populateResults)
